import { CardMedia, Link } from "@material-ui/core";
import { useSelector } from "react-redux";

import Logo_LP_ALD from "../../../assets/img/logo/Logo_LP_ALD.png";
import LogoAyvensImage from "../../../assets/img/logo/logo.png";
import LogoOCImage from "../../../assets/img/logo/logoFams.svg";
import LogoFAMS from "../../../assets/img/logo/resizedFAMSLogo.png";
import { selectFormType } from "../../formSettings.slice";

/*import styles, { logoFAMS } from "./Logo.module.scss";*/
import styles from "./Logo.module.scss";

/*
export const Logo = (): JSX.Element => {
    const formType = useSelector(selectFormType);
    const logo = formType.includes("oc_")
        ? { class: styles.logoFAMS, img: LogoOCImage }
        : { class: styles.logoLP, img: LogoACImage };

    return (
        <Link href="https://www.leaseplan.com/pl-pl/">
            <CardMedia className={logo.class} component="img" src={logo.img} />
        </Link>
    );
};*/

/*const logo = { class: styles.logoLP, img: LogoFAMS };*/

export const Logo = (): JSX.Element => {
  const formType = useSelector(selectFormType);

  const logoFams = { class: styles.logoFAMS, img: LogoFAMS };
  /* JIRA LPPLWEBMOB-739 */
  /*
  const logo = formType.includes("oc_")
    ? { class: styles.logoFAMS, img: LogoOCImage }
    : { class: styles.logoLP, img: LogoACImage };
    */
  const logo = formType.includes("oc_")
    ? { class: styles.logoFAMS, img: LogoOCImage }
    : { class: styles.logoLP, img: LogoAyvensImage };
  return (
    <div className={styles.topBar}>
      <Link href="https://www.leaseplan.com/pl-pl/">
        <CardMedia className={logo.class} component="img" src={logo.img} />
      </Link>
      <Link href="https://www.leaseplan.com/pl-pl/">
        <CardMedia
          className={logoFams.class}
          component="img"
          src={logoFams.img}
        />
      </Link>
    </div>
  );
};
